// extracted by mini-css-extract-plugin
export var actionButton = "_ys-2";
export var card = "_ys-0";
export var disambiguationList = "_ys-3";
export var errorCard = "_ys-4";
export var row = "_ys-1";